import {LOCALES} from "../../lang";


const localReducer =(state= localStorage.getItem('lang') || LOCALES.GERMAN ,action)=>{
    switch (action.type) {
        case 'SETLOCAL':
            localStorage.setItem('lang',action.payload );
            return state =action.payload;
        default:
            return state;
    }
};


export default localReducer;
